import type { ReactElement } from 'react'
import { Component } from 'react'

import { MediaGroupStyled } from './styles/MediaGroupStyled'
import { Badge } from '../../elements/LegacyBadge'
import { type IMediaProps } from '../../elements/Media'

type ChildType = ReactElement<IMediaProps> | null

export interface IMediaGroupProps {
  /** Children of `Media` components */
  children: ChildType[] | ChildType
}

export class MediaGroup extends Component<IMediaGroupProps> {
  static defaultProps = {}

  render() {
    const { children } = this.props
    return (
      <MediaGroupStyled count={children instanceof Array && children.length}>
        {children}
        {children instanceof Array &&
          (children.length > 3 ? <Badge>{children.length}</Badge> : null)}
      </MediaGroupStyled>
    )
  }
}
